import request from '@/utils/request'

/**
 * @describe 获取查询记录列表
 * @param areaCodeCity
 * @param areaCodeDistrict
 * @param areaCodeSubdistrict
 * @param villageCode
 * @param entName
 * @param kssj
 * @param jssj
 * @param pageNum 1
 * @param pageSize 20
 */
export function pageSearchRecord(query) {
  return request({
    url: 'search/pageSearchRecord.do',
    method: 'GET',
    params: query
  })
}


/**
 * @describe 根据打印编码查询合格证信息
 * @param searchFrom (1-二维码扫描 2-绑码扫描 3-门户查询 4-大数据查询)
 * @param printCode
 */
export function searchByPrintCode(query) {
  return request({
    url: 'scan/searchByPrintCode.do',
    method: 'GET',
    params: query
  })
}

/**
 * @describe 根据打印编码查询合格证信息 HTTPS
 * @param 同上
 */
export function searchByPrintCodeHTTPS(query) {
  return request({
    url: 'search/searchByPrintCode.do',
    method: 'GET',
    params: query
  })
}


/**
 * @describe 删除查询记录
 * @param searchRecordId
 */
export function delSearchRecord(query) {
  return request({
    url: 'search/delSearchRecord.do',
    method: 'POST',
    data: query
  })
}

/**
 * @describe 查询追溯信息 - 纸质合格证
 * @param entId
 * @param pageNum
 * @param pageSize
 */
export function pageCertificatePaper(query) {
  return request({
    url: 'scan/pageCertificatePaper.do',
    method: 'POST',
    data: query
  })
}

/**
 * @describe 根据主体身份码查询企业信息
 * @param identityCode 身份码
 */
export function searchEntInfoByIdentityCode(query) {
  return request({
    url: 'scan/searchEntInfoByIdentityCode.do',
    method: 'POST',
    data: query
  })
}


